import PhotoArrowOverlay from '../src/PhotoArrowOverlay';
export default PhotoArrowOverlay;
